/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Flex, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import type { MenuSkeletonItemProps } from '../../../../types';
import messages from '../messages';

const LEGACY_MENU_SKELETON_HEIGHT = 40;
const LEGACY_CONTENT_HEIGHT = 9;
const DEFAULT_CONTENT_HEIGHT = 8;

const menuSkeletonStyles = cssMap({
	wrapperLegacy: {
		height: `${LEGACY_MENU_SKELETON_HEIGHT}px`,
		width: '100%',
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	wrapper: {
		height: '32px',
		width: '100%',
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
});

export const MenuSkeletonItem = ({
	testId,
	contentHeight = fg('navx-2644-loading-menu') ? DEFAULT_CONTENT_HEIGHT : LEGACY_CONTENT_HEIGHT,
}: MenuSkeletonItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<Stack
			xcss={
				fg('navx-2644-loading-menu') ? menuSkeletonStyles.wrapper : menuSkeletonStyles.wrapperLegacy
			}
			alignBlock="center"
			testId={testId}
		>
			<Flex alignItems="center">
				<Skeleton testId="skeleton-item-v2" width="100%" height={contentHeight} isShimmering />
			</Flex>
			<VisuallyHidden>{formatMessage(messages.menuItemLoading)}</VisuallyHidden>
		</Stack>
	);
};
